module.exports = __webpack_public_path__ + "img/logo_av_securities.36a1d609.png";